import React from 'react';
import * as Styled from './MTextBlockStandard.styles';
import { MTextBlockStandardProps, MTextBlockStandardAlignment } from './MTextBlockStandard.types';

import { AEyebrow, AEyebrowVariant } from '../../atoms/AEyebrow';
import { AHeader, AHeaderSize, AHeaderTag } from '../../atoms/AHeader';
import { AAccentLine, AAccentLineSize, AAccentLineAlignment } from '../../atoms/AAccentLine';

const COMPONENT_NAME = 'm-web-ui-kit-MTextBlockStandard';
const TEST_ID = 'web-ui-kit-MTextBlockStandard';

export const MTextBlockStandard: React.FC<MTextBlockStandardProps> = ({
  alignment = MTextBlockStandardAlignment.Left,
  eyebrowText,
  eyebrowVariant = AEyebrowVariant.Primary,
  headerText,
  headerSize = AHeaderSize.TitleM,
  headerTag,
  hasAccentLine = true,
  accentLineSize = AAccentLineSize.OnePx,
}) => {
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} alignment={alignment}>
      {eyebrowText && <AEyebrow variant={eyebrowVariant}>{eyebrowText}</AEyebrow>}
      <AHeader
        size={headerSize as AHeaderSize}
        text={headerText}
        {...(headerTag ? { element: headerTag as AHeaderTag } : {})}
      />
      {hasAccentLine && (
        <AAccentLine
          size={accentLineSize as AAccentLineSize}
          alignment={
            alignment === MTextBlockStandardAlignment.Center ? AAccentLineAlignment.Centered : AAccentLineAlignment.Left
          }
        />
      )}
    </Styled.Wrapper>
  );
};

export { MTextBlockStandardAlignment, TEST_ID as M_TEXT_BLOCK_STANDARD_TEST_ID };
